import { IS_WEBVIEW, IS_WEBVIEW_FROM_UA } from 'reactApp/appHelpers/configHelpers';
import { checkPromoForceQuery, MARCH_PROMO_ENABLED_QUERY_PARAM } from 'reactApp/hooks/useMarchPromo2026';
import { PROMO_BUTTON_QUERY_ID } from 'reactApp/sections/QuotaLanding/PromoButton/PromoButton.helpers';

export const makeMarchPromoURL = (restQuery: string) => {
    const queryParams = new URLSearchParams(window.location.search);
    const resultUrl = new URL(window.location.pathname, window.location.origin);
    const isWebview = IS_WEBVIEW || IS_WEBVIEW_FROM_UA;
    const isQueryForceMarchPromo = checkPromoForceQuery();

    const promoButtonTariff = queryParams.get(PROMO_BUTTON_QUERY_ID);
    const initTab = queryParams.get('initTab');

    if (isWebview) {
        resultUrl.searchParams.set('webview', 'true');
    }
    if (isQueryForceMarchPromo) {
        resultUrl.searchParams.set(MARCH_PROMO_ENABLED_QUERY_PARAM, 'true');
    }

    resultUrl.searchParams.set(PROMO_BUTTON_QUERY_ID, promoButtonTariff || 'W1TB_1y_ogogoblako_force_trial');

    if (initTab) {
        resultUrl.searchParams.set('initTab', initTab);
    }

    return resultUrl.toString() + (isWebview || isQueryForceMarchPromo ? '&' : '?') + restQuery;
};
